import { prop, map, pipe, forEach } from 'ramda';

/**
 * Transform error response to extract messages
 *
 * @param {object} response - Error response with detail array
 * @returns {string[]} Array of error messages
 */
export const extractMessages = pipe(
    prop('detail'),
    map(prop('msg'))
);

/**
 * Transform response and display each message using provided display function
 *
 * @param {function} displayFn - Display function (handleErrorAndDisplay, etc.)
 * @param {object} response - Error response with detail array
 * @param {any} extraArgs - Additional arguments to pass to displayFn
 * @returns {void}
 */
export const transformAndDisplay = (displayFn, response, extraArgs = {}) => 
    pipe(
        extractMessages,
        forEach(msg => displayFn(msg, extraArgs))
    )(response);

/**
 * Curried version for composable usage
 *
 * @param {function} displayFn - Display function (handleErrorAndDisplay, etc.)
 * @param {any} extraArgs - Additional arguments to pass to displayFn
 * @returns {function} Function that takes response and displays messages
 */
export const displayMessages = (displayFn, extraArgs = {}) => (response) =>
    transformAndDisplay(displayFn, response, extraArgs);

/**
 * Utility to check if response has detail array
 *
 * @param {object} response
 * @returns {boolean}
 */
export const hasDetailMessages = (response) => 
    response?.detail && Array.isArray(response.detail);